module.exports = __webpack_public_path__ + "basic.61f3a8a387a64abfc053.woff";


//////////////////
// WEBPACK FOOTER
// /Users/alexandre/Documents/web/riberfuso/resources/ng/src/assets/fonts/linea/basic.woff
// module id = ../../../../../src/assets/fonts/linea/basic.woff
// module chunks = 6